import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SimpleForm,
  Create,
  Edit,
  Show,
  SimpleShowLayout,
  FunctionField,
  ImageInput,
  ImageField,
  SelectInput,
  translate as t,
  ReferenceArrayInput,
} from 'admin-on-rest';

import { Link } from 'react-router-dom';

import {
  List as MaterialList,
  ListItem,
  FlatButton,
} from 'material-ui';

import queryString from 'query-string';

import CreateIcon from 'material-ui/svg-icons/content/add';
import EditIcon from 'material-ui/svg-icons/content/create';

import MenuListItemLink from '../components/MenuListItemLink';
import EditButton from '../components/button/EditButton';
import ThumbnailImageField from '../components/fields/ThumbnailImageField';
import '../styles/model/chapter/styles.css';
import '../styles/global.css';
import ReferenceInput from '../components/inputs/ReferenceInput';
import UrlParamsLinkButton from '../components/button/UrlParamLinkButton';
import SelectArrayInput from '../components/inputs/SelectArrayInput';
import { getTranslationByLocale } from '../utils/TranslationUtils';

const anchorStyle = {
  float: 'right',
  textAlign: 'center',
};

const styles = {
  NestedListItem: {
    backgroundColor: 'rbga(0,0,0,0)',
    transition: 'none',
  },
  Button: {
    display: 'inline-block',
  },
  Icons: {
    color: 'red',
  },
};

export const BookList = t((props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="title" label={props.translate('title')} />
      <ImageField source="icon" label={props.translate('icon')} />
      <EditButton {...props} />
    </Datagrid>
  </List>
));

export const BookCreate = t((props) => (
  <Create {...props}>
    <SimpleForm>
      <Link to="/books">
        <FlatButton primary>HOME</FlatButton>
      </Link>

      <TextInput source="title" label={props.translate('title')} />
      <ImageInput source="icon" label={props.translate('icon')} accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>

      <SelectInput
        label={props.translate('language')}
        source="language"
        choices={[
          { id: 'sv', name: 'Svenska' },
          { id: 'en', name: 'English' },
        ]}
      />

      <ReferenceInput {...props} source="genre" label={props.translate('academy.genre')} reference="genres">
        <SelectInput optionText={`name.${props.locale}`} />
      </ReferenceInput>

      <ReferenceArrayInput source="positions" reference="positions" label={props.translate('position')} allowEmpty>
        <SelectArrayInput
          source="positions"
          optionText={(choice) => getTranslationByLocale(choice.name, props.locale)}
          options={{ fullWidth: true, errorText: props.translate('positionsHintText'), errorStyle: { color: 'darkslategrey' }, floatingLabelFocusStyle: { color: 'darkslategrey' } }}
        />
      </ReferenceArrayInput>

    </SimpleForm>
  </Create>
));

const BookTitle = t(({ record }) => (
  <span>{record ? `${record.title}` : ''}</span>
));

export const BookEdit = t((props) => (
  <Edit title={<BookTitle />} {...props}>

    <SimpleForm redirect="edit">
      <Link to="/books">
        <FlatButton primary>{props.translate('home')}</FlatButton>
      </Link>

      <TextInput source="title" label={props.translate('title')} />
      <ImageInput source="icon" label={props.translate('icon')} accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>

      <ReferenceInput {...props} format={(genre) => genre && genre._id} source="genre" label={props.translate('academy.genre')} reference="genres" allowEmpty>
        <SelectInput optionText={`name.${props.locale}`} optionValue="_id" />
      </ReferenceInput>

      <SelectInput
        label={props.translate('language')}
        source="language"
        choices={[
          { id: 'sv', name: 'Svenska' },
          { id: 'en', name: 'English' },
        ]}
      />

      <ReferenceArrayInput source="positions" reference="positions" label={props.translate('position')} allowEmpty>
        <SelectArrayInput
          source="positions"
          optionText={(choice) => getTranslationByLocale(choice.name, props.locale)}
          options={{ fullWidth: true, errorText: props.translate('positionsHintText'), errorStyle: { color: 'darkslategrey' }, floatingLabelFocusStyle: { color: 'darkslategrey' } }}
        />
      </ReferenceArrayInput>

      <UrlParamsLinkButton
        resourceType="chapters"
        action="create"
        fields="bookId, bookName"
        values="_id, title"
        style={anchorStyle}
      >
        <FlatButton
          primary
          label={props.translate('create.item', { item: props.translate('academy.chapter') })}
          icon={<CreateIcon />}
        />
      </UrlParamsLinkButton>

      <FunctionField
        label={props.translate('academy.chapters')}
        render={(record) =>
          record.chapters && record.chapters.map((chapter) => (
            <MaterialList>
              <CustomList chapter={{ ...chapter }} bookTitle={record.title} {...props} />
            </MaterialList>)
          )
        }
      />
    </SimpleForm>
  </Edit>
));

export const BookShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
    </SimpleShowLayout>
  </Show>
);

export const CustomList = ({ chapter: { title: chapterTitle, _id: chapterId, bookId }, bookTitle, ...props }) => (
  <ListItem
    primaryText={chapterTitle}
    primaryTogglesNestedList
    nestedItems={[
      <ListItem style={styles.NestedListItem} key={1} className="ListItemParent">
        <MenuListItemLink to={{ pathname: `/chapters/${chapterId}`, state: props.location.pathname }} onClick={() => { }} style={styles.Button}>
          <EditIcon style={styles.Icons} />
          <div>
            {props.translate('edit.item', { item: props.translate('academy.chapter') }).toUpperCase()}
          </div>
        </MenuListItemLink>
        <MenuListItemLink
          to={{
            pathname: '/pages/create',
            search: queryString.stringify({ bookId, bookName: bookTitle, chapterId, chapterName: chapterTitle }),
            state: { prevPath: props.location.pathname } }}
          onClick={() => { }}
          style={styles.Button}
        >
          <CreateIcon style={styles.Icons} />
          <div>
            {props.translate('create.item', { item: props.translate('academy.page') }).toUpperCase()}
          </div>
        </MenuListItemLink>
        <MenuListItemLink
          to={{
            pathname: '/questions/create',
            search: queryString.stringify({ bookId, bookName: bookTitle, chapterId, chapterName: chapterTitle }),
            state: { prevPath: props.location.pathname } }}
          onClick={() => { }}
          style={styles.Button}
        >
          <CreateIcon style={styles.Icons} />
          <div>
            {props.translate('create.item', { item: props.translate('academy.question') }).toUpperCase()}
          </div>
        </MenuListItemLink>
      </ListItem>,
    ]}
  >
  </ListItem>
);
